import styled from '@emotion/styled'
import { theme, MediaQueries } from '@hhgtech/hhg-components'

import { CalendarRange } from 'interfaces/types'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledCalendar = styled.div`
  text-align: center;
  position: relative;
  &[data-toaster-visible='true'][data-cal-mode='yearly'] {
    padding-bottom: 88px;
  }
`

export const StyledCalendarMonthWrapper = styled.div`
  position: relative;
  padding: 16px 0;

  & + div::before {
    content: '';
    position: absolute;
    background-color: ${theme.colors.neutral100};

    [data-cal-mode='monthly'] & {
      width: 1px;
      top: 24px;
      bottom: 24px;
      left: 0;
    }
    [data-cal-mode='yearly'] & {
      height: 1px;
      top: 0;
      left: 16px;
      right: 16px;
    }
  }

  [data-cal-mode='monthly'] & {
    flex: 1;
    padding-bottom: 0;
  }
`

export const StyledCalendarMonths = styled.div`
  display: flex;
`

export const StyledCalendarMonthIndicator = styled.div`
  font-size: 20px;
  font-weight: 700;
`

export const StyledCalendarDaysWrapper = styled.div`
  margin: 0 auto;
  [data-cal-mode='monthly'] & {
    padding: 24px;
  }
`

export const StyledCalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  [data-cal-mode='weekly'] & {
    padding: 0 32px;
  }
  padding: 0 28px;
`

export const StyledCalendarDaysOfWeek = styled(StyledCalendarGrid)`
  background-color: white;
  height: 46px;
  border-radius: 0px 0px 6px 6px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`

export const StyledCalendarDateGrid = styled(StyledCalendarGrid)``

export const StyledCalendarDayLabel = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.gray400};
`

export const StyledCalendarDayNumberWrapper = styled.div<{
  range?: CalendarRange
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  ${MediaQueries.mbDown} {
    height: 36px;
  }

  ${MediaQueries.mbUp} {
    height: 40px;
  }

  &[data-is-range='true']::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${(props) =>
      props.range?.backgroundColor || 'rgba(0,0,0,0.1)'};
    z-index: 0;
  }

  &[data-is-range-first='true']::before {
    border-radius: 40px 0 0 40px;
    left: calc(50% - 20px);
    ${MediaQueries.mbUp} {
      [data-cal-mode='monthly'] & {
        left: 0;
      }
    }
  }

  &[data-is-range-last='true']::before {
    border-radius: 0 40px 40px 0;
    right: calc(50% - 20px);

    ${MediaQueries.mbUp} {
      [data-cal-mode='monthly'] & {
        right: 0;
      }
    }
  }

  &[data-is-today='true'][data-is-range='true']::before {
    ${MediaQueries.mbUp} {
      [data-cal-mode='monthly'] & {
        right: 0;
      }
    }
  }

  &[data-is-today='true'][data-is-selected='false'] > div::before {
    content: '';
    width: 9px;
    height: 9px;
    border-radius: ${theme.borderRadius};
    border: 1px solid ${theme.colors.white};
    position: absolute;
    background-color: ${(props) =>
      props.range?.color || theme.colors.primaryBase};
    left: 0;
    right: 0;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    /* z-index: 20; */
  }

  &[data-is-today='true'][data-is-selected='true'] > div {
    color: white;
    background-color: ${(props) =>
      props.range?.color || theme.colors.violet800};
  }

  ${(props) => props.range && `color: ${props.range.color};`}
`

export const StyledCalendarDayNumber = styled.div`
  position: relative;
  ${MediaQueries.mbDown} {
    width: 32px;
    height: 32px;
  }
  ${MediaQueries.mbUp} {
    width: 36px;
    height: 36px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  [data-is-today='true'] & {
    font-weight: ${theme.sizes.fwBold};
  }
  [data-is-selected='true'] & {
    border: 1px solid ${theme.colors.neutral500};
    border-radius: 32px;
  }
  [data-is-selected='true'][data-is-today='true'] & {
    border-color: transparent;
  }
`

export const StyledCalendarNavArrow = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  object-fit: contain;
  z-index: 11;
  top: 16px;
  cursor: pointer;

  ${MediaQueries.mbUp} {
    width: 16px;
    height: 16px;
  }

  [data-cal-mode='monthly'] & {
    width: 24px;
    height: 24px;
    border-radius: 12px;
    padding: 0;
  }

  &.cal-nav-prev {
    left: 16px;
  }

  &.cal-nav-next {
    right: 16px;
    transform: rotateZ(180deg);
  }
`

export const StyledCalendarMarkerIcon = styled.div`
  position: absolute;
  width: 85%;
  height: 85%;
  border-radius: 50%;
  border: 1px dashed;
`

export const StyledCalendarTooltip = styled.div`
  position: absolute;
  z-index: 10;
  top: 37px;
  left: 0;

  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: ${theme.borderRadius};
  background-color: white;
  padding: 8px 8px 8px 32px;

  p {
    white-space: nowrap;
  }

  &:hover {
    display: none;
  }
`

export const StyledCalendarTooltipIcon = styled.div`
  position: absolute;
  top: 12px;
  left: 8px;
`

export const StyledCalendarTooltipContent = styled.div`
  text-align: left;
  p .rate.highlighted {
    color: ${theme.colors.primaryBase};
    /* font-weight: 700; */
  }
`

export const StyledCalendarToaster = styled.div`
  position: fixed;
  bottom: 0;
  left: -16px;
  right: -16px;
  height: 88px;

  padding: 16px 56px;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.1);
  background-color: white;
`

export const StyledCalendarToasterIcon = styled.div`
  position: absolute;
  left: 30px;
  top: 18px;
`

export const StyledCalendarToasterCloseButton = styled.img`
  position: absolute;
  top: 16px;
  right: 32px;
  width: 24px;
  height: 24px;
  cursor: pointer;
`
